// src/index.ts

import "./class-component-hooks";
import Vue from "vue";

import vuetify, { i18n } from "./plugins/vuetify";
import VueCompositionApi from "@vue/composition-api";

import { firestorePlugin } from "vuefire";
import App from "./components/App.vue";

import VueI18n from "vue-i18n";

import VueRouter from "vue-router";
import router from "./router/router";

import firebase from "firebase/app";
import "firebase/storage";
import "firebase/firestore";
import "firebase/functions";
import annotationPlugin from "chartjs-plugin-annotation";
import zoomPlugin from "chartjs-plugin-zoom";
import "hammerjs";

import VueTheMask from "vue-the-mask";

import VueObserveVisibility from "vue-observe-visibility";
import InfinteLoading from "vue-infinite-loading";
import "vue-material-design-icons/styles.css";
import "@/styles/dark-text.scss";
import MenuIcon from "vue-material-design-icons/Menu.vue";
import SearchIcon from "vue-material-design-icons/Magnify.vue";
import PortalVue from "portal-vue";
import store from "@/store";
import StateButtonComponent from "@/components/common/StateButton.vue";
import { clearCacheAndModules } from "@/utils/Utils";
import { guardAxiosWrites, guardCallables, guardPrototypeMethods } from "@/utils/ViewAsWriteGuard";
import { isViewAsSelected } from "@/utils/ViewAs";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import { iresAxiosInstance } from "@/api/IresApi";
import { clearSecureLocalStorage } from "@/utils/SecureLocalStorage";
import { takeSignInRefusal } from "@/utils/SignInRefusal";
import {
  didSessionEnd,
  clearSessionEnded,
} from "@/data/repository/UserRepository";

export const app = firebase.initializeApp({
  apiKey: "AIzaSyCKzOdQ0jS6goT1lQMwptsQ4ID2lPZGmFg",
  authDomain: "ires-cloud.firebaseapp.com",
  region: "europe-west1",
  databaseURL: "https://ires-cloud.firebaseio.com",
  projectId: "ires-cloud",
  storageBucket: "ires-cloud.appspot.com",
  messagingSenderId: "454296501256",
  appId: "1:454296501256:web:e3c4d05efb30154353a5bd",
});

export const db = firebase.firestore(app);
export const storage = firebase.storage(app);
export const functions = app.functions("europe-west1");

// "Sicht auf" is read-only (ticket 2610051): while another user is shown, every write is refused at
// the four places all of IRES Office's writes pass through. The UI hides or disables actions too;
// this is what holds when it misses one. See src/utils/ViewAsWriteGuard.ts.
const viewAsWriteGuard = {
  isViewing: isViewAsSelected,
  onRefused: () => SnackbarModule.showError({ key: "common.viewAsReadOnly" }),
};
guardPrototypeMethods(firebase.firestore.DocumentReference.prototype, ["set", "update", "delete"], "DocumentReference", true, viewAsWriteGuard);
guardPrototypeMethods(firebase.firestore.CollectionReference.prototype, ["add"], "CollectionReference", true, viewAsWriteGuard);
guardPrototypeMethods(firebase.firestore.WriteBatch.prototype, ["commit"], "WriteBatch", true, viewAsWriteGuard);
guardPrototypeMethods(firebase.firestore.Transaction.prototype, ["set", "update", "delete"], "Transaction", false, viewAsWriteGuard);
// The v7 typings declare storage's Reference as an interface only; its prototype is a real reference's.
guardPrototypeMethods(Object.getPrototypeOf(storage.ref()), ["put"], "Storage", false, viewAsWriteGuard);
guardCallables(functions, viewAsWriteGuard);
guardAxiosWrites(iresAxiosInstance, viewAsWriteGuard);
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
Chart.register(annotationPlugin);
Chart.register(zoomPlugin);

Vue.use(VueCompositionApi);
Vue.use(VueObserveVisibility);
Vue.use(PortalVue);
Vue.use(VueTheMask);
Vue.use(VueI18n);
Vue.use(firestorePlugin);
Vue.use(VueRouter);
Vue.use(InfinteLoading);

Vue.component("menu-icon", MenuIcon);
Vue.component("search-icon", SearchIcon);
Vue.component("state-button", StateButtonComponent);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      clearCacheAndModules(!user);

      if (!user) {
        const sessionEnd = didSessionEnd();
        const refusedReason = takeSignInRefusal();

        clearSessionEnded();
        clearSecureLocalStorage();

        if (refusedReason) {
          // #2610066: signed out because the client or user is blocked; the login screen says so.
          router.replace({
            path: "/login",
            query: {
              refusedReason,
            },
          });
        } else if (sessionEnd) {
          router.replace({
            path: "/login",
            query: {
              sessionEnd: "1",
            },
          });
        } else {
          if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/resetPassword') {
            router.replace('/login');
          }
        }
      }
    });
  },
}).$mount("#app");
